import React from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import Link, { withPrefix } from 'gatsby-link'
import { observer, inject } from 'mobx-react'
import { autorun, toJS } from 'mobx'
import {
  Form,
  Grid,
  Container,
  Dropdown,
  Header,
  Image,
  Icon,
  Message,
} from 'semantic-ui-react'
import { isMobile } from 'react-device-detect'
import { DateInput } from 'semantic-ui-calendar-react'
import LazyLoad from 'react-lazyload'
import { parse as qsParse } from 'query-string'

import FlightPreview from '../components/FlightPreview'
import AirlineLogo from '../components/AirlineLogo'

import { DiscussionEmbed } from 'disqus-react'
import FreshChat from 'react-freshchat'

const currencyOpts = require('currency-codes/data').map(
  ({ currency, code }) => {
    return {
      text: code,
      value: code,
      key: code,
    }
  }
)

@inject('FlightStore')
@inject('AirportAutocomplete')
@observer
class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.scrollToFlights = this.scrollToFlights.bind(this)
  }

  componentDidMount() {
    const that = this
    const { ref: referralCode, promoCode, from, to } = qsParse(
      this.props.location.search
    )
    this.props.FlightStore.referralCode = referralCode
    this.props.FlightStore.promoCode = promoCode
    this.props.FlightStore.from = from
    this.props.FlightStore.to = to
    if ((from + to).length === 6) {
      this.props.FlightStore.searchFlights()
    }

    autorun(() => {
      const { flights } = this.props.FlightStore
      if (toJS(flights).length > 0) {
        setTimeout(that.scrollToFlights, 200)
      }
    })
  }

  scrollToFlights() {
    try {
      const { offsetTop } = ReactDOM.findDOMNode(this.refs.flightResults)
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      })
    } catch (err) {
      console.warn("Couldn't scrollToFlights", err)
    }
  }

  render() {
    const {
      from,
      to,
      when,
      returnDate,
      currency,
      firstName,
      lastName,
      isRoundTrip,
    } = this.props.FlightStore
    const {
      flights,
      routeStats,
      loading,
      freshChatConfig,
      DATE_FORMAT,
      err,
    } = this.props.FlightStore
    const { handleChange, searchFlights } = this.props.FlightStore
    const {
      airportSuggest,
      fromOptions,
      toOptions,
    } = this.props.AirportAutocomplete

    return (
      <div>
        <Container text textAlign='left'>
          <Header
            as='h2'
            textAlign='center'
            content='Generate your fake flight ticket here'
          />
          <Link
            to={withPrefix('/FakeFlightTickets.com-SampleV2.pdf')}
            rel='noindex nofollow'
            target='_blank'>
            <Image
              className='ticketSample'
              src={withPrefix('/FakeFlightTickets.com-SampleV2.jpg')}
              size='small'
              floated='right'
            />
          </Link>
          <p className='hero'>
            <i>Proof of Onward Travel</i> is required by many countries before you even
            board an ✈️ airplane. If you'd like to keep your travel options open & travel
            on one-way tickets, this hack is perfect for you! Use this for pranks and
            anything you like, except for real flights.
            <br />
            <br />
            We use <b>real</b> flight data & <b>real</b> ticket template, to generate a{' '}
            <b>dummy</b> ticket. Must read{' '}
            <a href='/faq' target='_blank'>
              FAQ
            </a>{' '}
            before using 👇
            {/*Take a look at this <Link to={withPrefix('/FakeFlightTickets.com-SampleV2.pdf')} target='_blank' ><Icon name='paperclip'/> Ticket-example.pdf</Link>*/}
          </p>
          <Form
            size='large'
            className={`searchFlightsForm ${isRoundTrip ? 'isRoundTrip' : ''}`}>
            <Form.Group className='one-way-round-trip' inline>
              <Form.Radio
                name='isRoundTrip'
                label='One way'
                value={false}
                checked={!isRoundTrip}
                onChange={handleChange}
              />
              <Form.Radio
                name='isRoundTrip'
                label='Round trip'
                value={true}
                checked={isRoundTrip}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Dropdown
                name='from'
                label='🛫 From'
                placeholder='DPS'
                value={from}
                options={fromOptions}
                onKeyUp={airportSuggest.bind(this, 'fromOptions')}
                onChange={handleChange}
                search={(opts, q) => opts}
                selection
                fluid
              />
              <Form.Dropdown
                name='to'
                label='🛬 To'
                placeholder='KUL'
                value={to}
                options={toOptions}
                onKeyUp={airportSuggest.bind(this, 'toOptions')}
                onChange={handleChange}
                search={(opts, q) => opts}
                selection
                fluid
              />
              <div className='field'>
                <label>📆 When</label>
                <DateInput
                  popupPosition={isMobile ? 'bottom center' : 'top left'}
                  name='when'
                  dateFormat={DATE_FORMAT}
                  placeholder={DATE_FORMAT}
                  value={when}
                  closable={true}
                  startMode='day'
                  hideMobileKeyboard={true}
                  animation={false}
                  onChange={handleChange}
                  className={!moment(when, DATE_FORMAT).isValid() && 'error'}
                />
              </div>
              {isRoundTrip && (
                <div className='field'>
                  <label>📆 Return</label>
                  <DateInput
                    popupPosition={isMobile ? 'bottom center' : 'top left'}
                    name='returnDate'
                    dateFormat={DATE_FORMAT}
                    placeholder={DATE_FORMAT}
                    value={returnDate}
                    closable={true}
                    startMode='day'
                    hideMobileKeyboard={true}
                    animation={false}
                    onChange={handleChange}
                    className={!moment(returnDate, DATE_FORMAT).isValid() && 'error'}
                  />
                </div>
              )}
            </Form.Group>

            <Form.Group widths='equal' className='hide'>
              <Form.Dropdown
                name='currency'
                value={currency}
                placeholder='Currency'
                options={currencyOpts}
                selection
                fluid
                search
                autoComplete='off'
                disabled
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group widths='equal' className='hide'>
              <Form.Input
                name='firstName'
                placeholder='Peter'
                label='Your First Name'
                required={true}
                onChange={handleChange}
              />
              <Form.Input
                name='lastName'
                placeholder='Pan'
                label='Last Name'
                required={true}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Button
              content="Let's go!"
              color='green'
              size='large'
              fluid
              onClick={searchFlights}
              {...{ loading }}
            />
          </Form>
        </Container>

        <Container className='airline-logos'>
          <LazyLoad once>
            <AirlineLogo src='data:image/png;base64,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' />
            <AirlineLogo code='EK' />
            <AirlineLogo code='3K' />
            <AirlineLogo code='UA' />
            <AirlineLogo code='CX' />
            <AirlineLogo code='TG' />
            <AirlineLogo code='MH' />
            <AirlineLogo code='CZ' />
            <AirlineLogo code='DL' />
            <AirlineLogo code='F9' />
            <AirlineLogo src='https://seeklogo.com/images/A/Air_Asia-logo-5ACDC17858-seeklogo.com.png' />
            <p>
              All major airlines and currencies are supported.
              <br />
              Flight information (time, flight number, price, etc) is <b>legit</b>.
            </p>
          </LazyLoad>
        </Container>

        <Container text>
          <div className='flights' ref='flightResults'>
            {flights.length ? (
              <Header as='h2' content={`Found ${flights.length} flights:`} />
            ) : null}
            {flights.length ? (
              <Message size='small' color='grey'>
                ✈️ <b>Pro tip:</b> Select an <b>airline</b> that is <b>different</b> from
                the one you are actually flying with.
              </Message>
            ) : null}

            {routeStats ? (
              <Message size='small' icon negative>
                <Icon name='exclamation' />
                <Message.Content>
                  <Message.Header>
                    Are you traveling from {routeStats.flyFrom} airport?
                  </Message.Header>
                  <p>
                    {routeStats.failures} out of {routeStats.total} travelers (
                    {Math.round((1 - routeStats.rate) * 100)}%) report issues while
                    traveling from {routeStats.flyFrom} airport. Please be ready to book a
                    real refundable onward flight on the spot.{' '}
                  </p>
                </Message.Content>
              </Message>
            ) : null}
            <br />
            {flights
              ? flights.map((flight, key) => {
                  return <FlightPreview key={key} {...flight} when={when} />
                })
              : null}
          </div>

          {err && (
            <Message
              warning
              header={err && err.message}
              content={err.description}
              textAlign='center'
              icon='search'
            />
          )}

          {flights.length ? (
            <center>You arrived at the end of the list.</center>
          ) : (
            <div className='flightResultsPlaceholder'>
              Enter your origin and destination airports above 👆{' '}
              <br className='hide-mobile' />
              and flights will appear here.
            </div>
          )}
          <div style={{ marginTop: '3em' }} />
          {/*<LazyLoad once>
          <DiscussionEmbed shortname='fake-flight-tickets' config={{
            url: `https://www.fakeflighttickets.com/`,
            identifier: 'landing-page',
            title: 'Fake Flight Tickets'
          }} />
        </LazyLoad>*/}
        </Container>
        {/*
        {typeof window !== 'undefined' ? <FreshChat {...freshChatConfig} /> : null}
      */}
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.jsx